import { neutral4 } from '../../colors';

export const classes = {
  dividers: {
    borderTop: `1px solid ${neutral4}`,
    borderBottom: `1px solid ${neutral4}`,
  },
};
